export const Web = 'web'

export const Electron = 'electron'

export const Remote = 'remote'
